module.exports = __webpack_public_path__ + "static/img/exchangeDoc.e61c318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/exchangeDoc.png
// module id = 706
// module chunks = 2